import { render, staticRenderFns } from "./FBA.vue?vue&type=template&id=3fb8a041&scoped=true"
import script from "./FBA.vue?vue&type=script&lang=js"
export * from "./FBA.vue?vue&type=script&lang=js"
import style0 from "./FBA.vue?vue&type=style&index=0&id=3fb8a041&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8a041",
  null
  
)

export default component.exports